module.exports = __webpack_public_path__ + "static/media/language6.8371d8d0.png";